import React from 'react'
import { TooltipWrapper, IconWrapperLink, IconWrapperButton, ProfileName } from './style'

const IconsWrapper = ({
  to = null,
  title,
  onClick,
  children,
  isProfile = false,
  active = false,
}) => {
  if (isProfile) {
    return (
      <TooltipWrapper title={title} placement='right'>
        <ProfileName onClick={onClick}>{children}</ProfileName>
      </TooltipWrapper>
    )
  }

  return (
    <TooltipWrapper title={title} placement='right'>
      {to ? (
        <IconWrapperLink to={to} onClick={onClick} className={active ? 'active' : ''}>
          {children}
        </IconWrapperLink>
      ) : (
        <IconWrapperButton onClick={onClick}>{children}</IconWrapperButton>
      )}
    </TooltipWrapper>
  )
}

export default IconsWrapper
